export default __webpack_public_path__ + "static/media/download.0d69f911.svg";